import React, { Component } from 'react';

import SectionTitle from './Section/SectionTitle';
import SectionBar from './Section/SectionBar';
import SectionCorner from './Section/SectionCorner';

import Ratio from 'react-ratio';

import ReactPlayer from 'react-player'

class SectionRecruitment extends Component {
  state = {
    playing: false,
    muted: false,
  }
  componentDidMount() {
    document.addEventListener("scroll", this.isInViewport);
  }
  componentWillUnmount() {
    document.removeEventListener("scroll", this.isInViewport);
  }
  isInViewport = () => {
      const top = this.viewElement.getBoundingClientRect().top;
      if(top <= window.innerHeight-window.innerHeight*0.1){
          this.setState({playing:true, muted:true});
      }
  };
  onClick=()=>{
    this.setState({muted:false});
  }

  render() {
    const { playing, muted } = this.state;

    const length = this.props.width;
    let section1length, extraBarOffset;
    switch (length) {
      default:
      section1length = 220;
      extraBarOffset = 58;
      break;
      case 'xs':
       section1length = 220;
      extraBarOffset = 50;
      break;
    }

    const barColor = '#e24b4b';

    const { barOffset, horizontalOffset, width } = this.props;
    let setRef = (el) => {
      this.viewElement = el;
    };
    return (
      <section id="recrutement" className="SectionRecruitment Section" style={this.props.style || {}}>
            <SectionBar length={section1length} color={barColor} direction={'vertical'}/>
            <div className="videoWrapper" onClick={this.onClick}>
              <div className="video" ref={setRef}>
                  <Ratio ratio={16/9}>
                    <ReactPlayer controls={true} playing={playing} muted={muted} width='100%' height='100%' url='lobster_-_site_v3_-_video_(540p).mp4' style={{backgroundColor:'black'}} config={{ file: { attributes: { controlsList: 'nodownload' } } }}/>
                    {/*<iframe title="Recrutement" src="https://player.vimeo.com/video/290590719?transparent=false" width="100%" height="100%" frameBorder="0" webkitallowfullscreen="1" mozallowfullscreen="1" allowfullscreen="1"></iframe>*/}
                  </Ratio>
              </div>
            </div>
            <div style={{position: 'relative'}} className="footer">
              <SectionBar length={58} color={barColor} direction={'vertical'}/>
              <SectionCorner length={50} style={{marginLeft: -58}} corner={'bl'} color={barColor} />
              <SectionBar length={Math.round(barOffset/2)} style={{top: 48, marginLeft: ((barOffset-horizontalOffset)*-1)}} color={barColor} direction={'horizontal'}/>
              <SectionCorner length={50} style={{top:116, marginLeft: (((barOffset)*-1))}} corner={'tl'} color={barColor}/>
              <SectionBar length={10} style={{top: 98, marginLeft: (((barOffset-horizontalOffset)+extraBarOffset)*-1)}} color={barColor} direction={'vertical'}/>
            </div>

        </section>
      );
    }
  }

  export default SectionRecruitment;



// WEBPACK FOOTER //
// ./src/components/Home/SectionRecruitment.jsx